// gatsby-browser.js
import './src/styles/global.css';


let lastConsentKey = null

function computeConsent(categories) {
    const analyticsGranted = categories.includes("analytics")
    const marketingGranted = categories.includes("marketing")

    return {
        analytics_storage: analyticsGranted ? "granted" : "denied",
        ad_storage: marketingGranted ? "granted" : "denied",
        ad_user_data: marketingGranted ? "granted" : "denied",
        ad_personalization: marketingGranted ? "granted" : "denied",
    }
}

function pushConsentIfChanged(categories) {
    const consent = computeConsent(categories)
    const key = JSON.stringify(consent)

    // Prevent duplicate pushes for the same state
    if (key === lastConsentKey) return
    lastConsentKey = key

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        event: "consent_update",
        consent,
    })
}

export const onClientEntry = () => {
    const handler = (e) => {
        const cats = e?.detail?.cookie?.categories || []
        pushConsentIfChanged(cats)
    }

    // CookieConsent custom events
    window.addEventListener("cc:onFirstConsent", handler)
    window.addEventListener("cc:onChange", handler)
    window.addEventListener("cc:onConsent", handler)
}
